import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { TextAreaInterface } from 'common/types/entities/TextAreaInterface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from '../utils/generate-base-entity'

export function createTextArea(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): TextAreaInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.TextArea, parentId, masterBlockId),
    height: 200,
    fontSize: 18,
    backgroundColor: 'rgba(241, 244, 248, 1)',
    color: 'rgba(92, 104, 126, 1)',
    border: {
      radius: 3,
      width: 1,
      style: BorderStyleEnum.none,
    },
    padding: {
      paddingTop: 20,
      paddingRight: 20,
      paddingBottom: 20,
      paddingLeft: 20,
    },
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 25,
      marginLeft: 0,
    },
  }
}
